import { BankService } from "@/services";

const BankCard = () =>
  import(
    /* webpackChunkName: "bank-card" */ "@/components/AccountPage/Banking/BankingCard/BankCard"
  );
import $enDigits from "@/mixins/enDigits";

export default {
  name: "banking-card",
  components: { BankCard },
  mixins: [$enDigits],
  data() {
    return {
      cards: [],
      cardNumber: "",
      cardModal: false,
      isCardHover: false,
      isCardFocus: false,
      isRequesting: false,
      errorText: "",
      cardNumberRules: [
        v =>
          !!v ||
          this.$t(
            "accountPage.bankInformation.bankCards.modals.addCards.emptyInputCard"
          ),
        v =>
          /^\d{4}-\d{4}-\d{4}-\d{4}$/.test(v) ||
          this.$t(
            "accountPage.bankInformation.bankCards.modals.addCards.invalidInputCard"
          )
      ]
    };
  },
  computed: {
    // cardNameClass() {
    //   if (this.isCardFocus) {
    //     return "card_name_focus";
    //   } else {
    //     if (!this.isCardNumberValid) {
    //       return "card_name_error";
    //     } else {
    //       if (this.cardNumber) {
    //         return "card_name_fill";
    //       } else {
    //         if (this.isCardHover) {
    //           return "card_name_empty_hover";
    //         } else {
    //           return "card_name_empty";
    //         }
    //       }
    //     }
    //   }
    // },

    pureCardNumber() {
      return this.cardNumber?.replace(/-/gi, "");
    }

    // isCardNumberValid() {
    //   if (this.cardNumber) {
    //     const cardRegex = /^\d{4}-\d{4}-\d{4}-\d{4}$/;
    //     return cardRegex.test(this.cardNumber);
    //   }
    //   return true;
    // }
  },
  mounted() {
    !this.cards.length &&
      BankService.getCard().then(res => {
        this.cards = res.data.data;
      });
  },

  methods: {
    // checkValidation() {
    //   this.errorText = "";
    //   if (this.cardNumber) {
    //     if (!this.isCardNumberValid) {
    //       this.errorText = this.$t(
    //         "accountPage.bankInformation.bankCards.modals.addCards.invalidInputCard"
    //       );
    //     }
    //   } else {
    //     this.errorText = this.$t(
    //       "accountPage.bankInformation.bankCards.modals.addCards.emptyInputCard"
    //     );
    //   }
    // },

    startRequest() {
      this.isRequesting = true;
    },

    finishRequest() {
      this.isRequesting = false;
    },

    openCardModal() {
      this.cardModal = true;
    },

    closeCardModal() {
      this.cardModal = false;
    },

    addCard() {
      // this.checkValidation();
      if (this.cardNumber) {
        BankService.addCard(this.pureCardNumber)
          .then(res => {
            this.cards.push(res.data.data);
            this.$toast.success(res.data.message);
            this.closeCardModal();
            this.cardNumber = "";
          })
          .finally(() => this.finishRequest());
        this.startRequest();
      }
    },

    deleteCard(cardId) {
      this.cards = this.cards.filter(card => card.id !== cardId);
    },

    setCardHover(bool) {
      this.isCardHover = bool;
    },

    toggleCardFocus() {
      this.isCardFocus = !this.isCardFocus;
    }
  },
  watch: {
    cardNumber(number, oldValue) {
      // this.checkValidation();
      const value = this.$enDigits(number);
      const digitReg = /^\d+$/;
      this.cardNumber = value;
      const isDigit = digitReg.test(this.pureCardNumber);
      if (number) {
        if (isDigit) {
          let dashedNumber = this.pureCardNumber?.match(/.{1,4}/g);
          this.cardNumber = dashedNumber?.join("-");
        } else {
          this.cardNumber = oldValue;
        }
      }
    }
  }
};
